
      var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgX = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 17,
  height: 17,
  viewBox: "0 0 17 17"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "x_c9ce12095281c288__a",
  width: "200%",
  height: "200%",
  x: "-50%",
  y: "-38.2%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 2.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0.859703075 0 0 0 0 0.87142499 0 0 0 0 0.876811594 0 0 0 0.412587413 0"
})), /*#__PURE__*/React.createElement("filter", {
  id: "x_c9ce12095281c288__d",
  width: "150.7%",
  height: "150.7%",
  x: "-25.3%",
  y: "-25.3%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "SourceAlpha",
  result: "shadowBlurInner1",
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 2,
  dy: 1,
  in: "shadowBlurInner1",
  result: "shadowOffsetInner1"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetInner1",
  in2: "SourceAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic",
  result: "shadowInnerInner1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowInnerInner1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
})), /*#__PURE__*/React.createElement("circle", {
  id: "x_c9ce12095281c288__b",
  cx: 8.5,
  cy: 8.5,
  r: 8.5
}), /*#__PURE__*/React.createElement("path", {
  id: "x_c9ce12095281c288__c",
  d: "M12.259 4.857 8.808 8.318 5.346 4.862l-.489.474v.006l3.466 3.463-3.442 3.452.457.493h.008L8.8 9.282l3.454 3.45.497-.473v-.006L9.286 8.794l3.446-3.46-.465-.477z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#x_c9ce12095281c288__a)",
  xlinkHref: "#x_c9ce12095281c288__b"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#x_c9ce12095281c288__b"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  fill: "var(--theme-primary, #810ea9)",
  xlinkHref: "#x_c9ce12095281c288__c"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#x_c9ce12095281c288__d)",
  xlinkHref: "#x_c9ce12095281c288__c"
})))));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"17\" height=\"17\" viewBox=\"0 0 17 17\">\r\n    <defs>\r\n        <filter id=\"yvyqv3i31a\" width=\"200%\" height=\"200%\" x=\"-50%\" y=\"-38.2%\" filterUnits=\"objectBoundingBox\">\r\n            <feOffset dy=\"2\" in=\"SourceAlpha\" result=\"shadowOffsetOuter1\"/>\r\n            <feGaussianBlur in=\"shadowOffsetOuter1\" result=\"shadowBlurOuter1\" stdDeviation=\"2.5\"/>\r\n            <feColorMatrix in=\"shadowBlurOuter1\" values=\"0 0 0 0 0.859703075 0 0 0 0 0.87142499 0 0 0 0 0.876811594 0 0 0 0.412587413 0\"/>\r\n        </filter>\r\n        <filter id=\"ptszb0pfhd\" width=\"150.7%\" height=\"150.7%\" x=\"-25.3%\" y=\"-25.3%\" filterUnits=\"objectBoundingBox\">\r\n            <feGaussianBlur in=\"SourceAlpha\" result=\"shadowBlurInner1\" stdDeviation=\"1\"/>\r\n            <feOffset dx=\"2\" dy=\"1\" in=\"shadowBlurInner1\" result=\"shadowOffsetInner1\"/>\r\n            <feComposite in=\"shadowOffsetInner1\" in2=\"SourceAlpha\" k2=\"-1\" k3=\"1\" operator=\"arithmetic\" result=\"shadowInnerInner1\"/>\r\n            <feColorMatrix in=\"shadowInnerInner1\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0\"/>\r\n        </filter>\r\n        <circle id=\"aw9j2gtk5b\" cx=\"8.5\" cy=\"8.5\" r=\"8.5\"/>\r\n        <path id=\"2iwzmg9dzc\" d=\"M12.259 4.857L8.808 8.318 5.346 4.862 4.857 5.336 4.857 5.342 8.323 8.805 4.881 12.257 5.338 12.75 5.346 12.75 8.8 9.282 12.254 12.732 12.751 12.259 12.751 12.253 9.286 8.794 12.732 5.334 12.267 4.857z\"/>\r\n    </defs>\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <g>\r\n            <g>\r\n                <g transform=\"translate(-230 -99) translate(230 99)\">\r\n                    <use fill=\"#000\" filter=\"url(#yvyqv3i31a)\" xlink:href=\"#aw9j2gtk5b\"/>\r\n                    <use fill=\"#FFF\" xlink:href=\"#aw9j2gtk5b\"/>\r\n                </g>\r\n                <g transform=\"translate(-230 -99) translate(230 99)\">\r\n                    <use fill=\"var(--theme-primary, #810ea9)\" xlink:href=\"#2iwzmg9dzc\"/>\r\n                    <use fill=\"#000\" filter=\"url(#ptszb0pfhd)\" xlink:href=\"#2iwzmg9dzc\"/>\r\n                </g>\r\n            </g>\r\n        </g>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/x.c9ce12095281c288c48e935f6a10f839.svg"),
        {
          React: SvgX,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      